export default {
  "content": "<path d=\"M15 0a5 5 0 015 5v15L10 10 0 0h15z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20"
  }
};